module.exports = __webpack_public_path__ + "static/media/website-img.9b0785fb.svg";